import axios from 'axios';
import router from '../../../router/routes';

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: null,
    },

    getters: {
        authenticated(state) {
            return state.authenticated;
        },

        user(state) {
            return state.user;
        },
    },

    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value;
        },

        SET_USER(state, value) {
            state.user = value;
        },
    },

    actions: {
        register({ commit, dispatch }, credentials) {
            return new Promise((resolve, reject) => {
                commit('overlay/toggle', true, { root: true });

                axios.get('/sanctum/csrf-cookie')
                    .then(() => {
                        axios.post('/register', credentials)
                            .then(() => {
                                dispatch('me')
                                    .then(response => {
                                        resolve(response);
                                    })
                                    .catch(error => {
                                        commit('overlay/toggle', false, { root: true });
                                        reject(error.response);
                                    });
                            })

                            .catch(error => {
                                commit('overlay/toggle', false, { root: true });
                                reject(error.response);
                            });
                    });
            });
        },

        async signIn({ commit, dispatch }, credentials) {
            commit('overlay/toggle', true, { root: true });
            await axios.get('/sanctum/csrf-cookie');
            await axios.post('/login', credentials);
            return dispatch('me');
        },

        me({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get('/api/user')
                    .then((response) => {
                        commit('SET_AUTHENTICATED', true);
                        commit('SET_USER', response.data);
                        commit('overlay/toggle', false, { root: true });
                        resolve(response.data);
                    })
                    .catch(() => {
                        commit('SET_AUTHENTICATED', false);
                        commit('SET_USER', null);
                        commit('overlay/toggle', false, { root: true });
                        reject();
                    });
            });
        },

        async signOut({ commit }) {
            commit('overlay/toggle', true, { root: true });
            await axios.post('/logout').then(() => {
                document.cookie = "XSRF-TOKEN=; Domain=.swyft.local; Path=/; Expires=Mon, 06 Oct 1975 00:00:01 GMT;";
                commit('SET_AUTHENTICATED', false);
                commit('SET_USER', null);
                router.push({ name: 'Login' });
            });
        },

        getAuth({ state }) {
            return new Promise((resolve) => {
                resolve(state.user);
            });
        },
    },
};
